import { render } from "./BigFiveResults.vue?vue&type=template&id=48d7ae07&scoped=true"
import script from "./BigFiveResults.vue?vue&type=script&lang=js"
export * from "./BigFiveResults.vue?vue&type=script&lang=js"

import "./BigFiveResults.vue?vue&type=style&index=0&id=48d7ae07&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-48d7ae07"

export default script